export { DisplayOXXOPayBrand } from './display-oxxopay-brand';
